<template>
  <iframe class="neo-login-container" :src="url"> </iframe>

  <!-- <div class="quinyx-sign-in-redirect">
    <div class="content">
      <div class="header">
        <h1>Please log into your Neo account</h1>
      </div>
      <div class="sign-in-button">
        <a
          :href="url"
          target="_blank"
          class="request-demo-link"
          @click="update"
        >
          <md-button class="md-accent"> Log in to Neo </md-button>
        </a>
      </div>
    </div>
  </div> -->
</template>

<script>
import params from "../helpers/params";

export default {
  name: "QuinyxLogInRedirect",
  data: () => ({}),
  computed: {
    url() {
      return params.getParameterValue("NEO_URL");
    },
  },
  methods: {
    update() {
      window.addEventListener("focus", function () {
        window.location.reload(false);
      });
    },
  },
};
</script>

<style>
.neo-login-container {
  position: fixed;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  width: 100%;
  height: 100%;
  border: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  z-index: 999999;
}
.quinyx-sign-in-redirect {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.alfa-quinyx-sign-in .quinyx-sign-in-redirect {
  background-color: #fff;
}
.quinyx-sign-in-redirect .header h1 {
  color: #41494d;
}
.quinyx-sign-in-redirect .content {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: 100px;
}
.sign-in-button {
  margin-top: 10px;
}
.sign-in-button button {
  color: #fff !important;
  width: 250px;
  border-radius: 4px;
  border: 1px solid #2c9199;
  border-top-color: rgb(44, 145, 153);
  border-top-style: solid;
  border-top-width: 1px;
  border-right-color: rgb(44, 145, 153);
  border-right-style: solid;
  border-right-width: 1px;
  border-bottom-color: rgb(44, 145, 153);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-left-color: rgb(44, 145, 153);
  border-left-style: solid;
  border-left-width: 1px;
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;
  background-color: #2c9199;
}
.sign-in-button button:active,
.sign-in-button button:focus {
  background-color: #004851 !important;
  border-color: #004851;
}
.sign-in-button button:hover {
  background-color: #30a6af !important;
  border-color: #30a6af;
}
</style>



// WEBPACK FOOTER //
// QuinyxLogInRedirect.vue?766dcd9e